import React, { forwardRef, useEffect, useState, useImperativeHandle } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import axios from "../../../config/axiosConfig";
import CentroEquipoDetalleDialog from "../../requerimiento/components/CentroEquipoDetalleDialog";

const headCellSx = {
  fontWeight: 800,
  bgcolor: (t) => (t.palette.mode === "dark" ? t.palette.background.paper : t.palette.grey[100]),
};
const cellSx = {
  "& .MuiTableCell-root": { py: 0.1, px: 0.6, fontSize: 10.5, lineHeight: 1.3 },
};

const EquiposAsignadosOT = forwardRef(({ cod_ot, onData }, ref) => {
  const [radios, setRadios] = useState([]);
  const [baterias, setBaterias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [equipoDialog, setEquipoDialog] = useState(null);

  const fetchData = () => {
    if (!cod_ot) return;
    setLoading(true);
    Promise.all([
      axios.get(`/api/historial-radio?cod_ot=${cod_ot}`),
      axios.get(`/api/historial-bateria?cod_ot=${cod_ot}`)
    ])
      .then(([resRadios, resBaterias]) => {
        setRadios(resRadios.data);
        setBaterias(resBaterias.data);
        onData?.({ radios: resRadios.data, baterias: resBaterias.data });
      })
      .catch((err) => console.error("Error al cargar historiales", err))
      .finally(() => setLoading(false));
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(fetchData, [cod_ot]);
  
  useImperativeHandle(ref, () => ({ refetch: fetchData }));
  

  if (loading) return <CircularProgress />;

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.5 }}>
        Radios asignados
      </Typography>
      <TableContainer component={Paper} variant="outlined" sx={{ mb: 1.5, maxHeight: 220, borderRadius: 0.5 }}>
        <Table size="small" stickyHeader sx={cellSx}>
          <TableHead>
            <TableRow>
              <TableCell sx={headCellSx}>Serie</TableCell>
              <TableCell sx={headCellSx}>Modelo</TableCell>
              <TableCell sx={headCellSx}>Ciudad</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!radios.length ? (
              <TableRow>
                <TableCell colSpan={3}>
                  <Box sx={{ textAlign: "center", py: 1.5, color: "text.secondary" }}>
                    <Inventory2OutlinedIcon sx={{ fontSize: 28, mb: 0.5, opacity: 0.5 }} />
                    <Typography variant="body2">No se adicionaron radios.</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : radios.map((r) => (
              <TableRow key={r.id_historial}>
                <TableCell>
                  <Box
                    component="span"
                    onClick={() => setEquipoDialog({ tipo: "radio", identificador: r.serie })}
                    sx={{ cursor: "pointer", color: "primary.main", textDecoration: "underline" }}
                  >
                    {r.serie}
                  </Box>
                </TableCell>
                <TableCell>{r.modelo}</TableCell>
                <TableCell>{r.ciudad_actual || r.ciudad}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.5 }}>
        Baterías asignadas
      </Typography>
      <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 220, borderRadius: 0.5 }}>
        <Table size="small" stickyHeader sx={cellSx}>
          <TableHead>
            <TableRow>
              <TableCell sx={headCellSx}>Serie</TableCell>
              <TableCell sx={headCellSx}>Modelo</TableCell>
              <TableCell sx={headCellSx}>Ciudad</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!baterias.length ? (
              <TableRow>
                <TableCell colSpan={3}>
                  <Box sx={{ textAlign: "center", py: 1.5, color: "text.secondary" }}>
                    <Inventory2OutlinedIcon sx={{ fontSize: 28, mb: 0.5, opacity: 0.5 }} />
                    <Typography variant="body2">No se adicionaron baterías.</Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : baterias.map((b) => (
              <TableRow key={b.id_historial}>
                <TableCell>
                  <Box
                    component="span"
                    onClick={() => setEquipoDialog({ tipo: "bateria", identificador: b.serie })}
                    sx={{ cursor: "pointer", color: "primary.main", textDecoration: "underline" }}
                  >
                    {b.serie}
                  </Box>
                </TableCell>
                <TableCell>{b.modelo}</TableCell>
                <TableCell>{b.ciudad_actual || b.ciudad}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <CentroEquipoDetalleDialog
        open={!!equipoDialog}
        tipo={equipoDialog?.tipo}
        identificador={equipoDialog?.identificador}
        onClose={() => setEquipoDialog(null)}
      />
    </Box>
  );
});

export default EquiposAsignadosOT;
